import { render, staticRenderFns } from "./coreProduct.vue?vue&type=template&id=b764c284&scoped=true"
import script from "./coreProduct.vue?vue&type=script&lang=js"
export * from "./coreProduct.vue?vue&type=script&lang=js"
import style0 from "./coreProduct.vue?vue&type=style&index=0&id=b764c284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b764c284",
  null
  
)

export default component.exports